<script>

import hash from "./hash";
import Lang from "../../lang/lang";

export default {
  data: function () {
    return {
      shown: false,
      wallets: null,
      wallet: null,
      address: '',
      network: null,
      amount: null,
      feeTimer: null,
      feeController: null,
      feeAmount: null,
      btcValue: 0,
      feeValue: 0,
      requesting: false,
      requestId: null,
      digitsFocused: false,
      digitsValue: '',
      digitsError: null,
      confirming: false,
      withdrawalSuccess: false,
      MIN_AMOUNT: 0.0005,
      show() {
        this.shown = true;
        document.querySelector('body').style.overflowY = 'hidden';

        fetch(window['API_URL'] + '/api/v4/my-finances/wallets', {
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token')
          }
        }).then(res => res.json())
            .then(res => {
              this.wallets = res.data;
              if (this.wallets.length === 1) {
                this.wallet = this.wallets[0];
              }
            });
      },
      hide() {
        this.shown = false;
        document.querySelector('body').style.overflowY = null;
      },
      complete() {
        document.location.reload();
      },
      shouldShowReceive() {
        return this.amount != null && !isNaN(this.amount) && this.amount > 0 && this.network != null;
      },
      calcFee() {
        if (this.feeAmount === this.amount) return;

        this.feeAmount = this.amount;
        if (this.feeTimer != null) {
          clearTimeout(this.feeTimer);
        }
        if (this.feeController != null) {
          this.feeController.abort();
        }

        if (!this.shouldShowReceive()) {
          this.btcValue = 0;
          this.feeValue = 0;
          return;
        }

        if (this.network === 'binance') {
          this.btcValue = this.amount;
          this.feeValue = 0;
          return;
        }

        this.btcValue = null;
        this.feeValue = null;
        this.feeTimer = setTimeout(() => {
          this.feeController = new AbortController();
          fetch(window['API_URL'] + '/api/v4/my-finances/tx-fee?' + new URLSearchParams(
              {
                address: 'any',
                value: this.amount
              }).toString(),
              {
                signal: this.feeController.signal,
                headers: {
                  'X-Auth-Token': window['xive']['getCookie']('x-auth-token')
                }

              }).then(res => res.json())
              .then(res => {
                let value = this.amount;
                this.feeValue = res.data;
                this.btcValue = value - this.feeValue;
              });
        }, 1000);
      },
      setMaxAmount() {
        this.amount = this.wallet.balance;
        if (!this.shouldShowReceive()) return;
        this.calcFee();
      },
      getAddressInfo() {
        if (this.address.length === 0) return null;

        if (this.network === 'binance') {
          if (this.address.startsWith('0x')) {
            return {
              network: 'mainnet'
            }
          } else {
            return 'error';
          }
        }

        try {
          return hash.parseAddress(this.address);
        } catch (e) {
          return "error";
        }
      },
      requestWithdrawal() {
        this.requesting = true;
        const paramsUrl = new URLSearchParams({
          network: this.network,
          address: this.address,
          walletId: this.wallet.id,
          value: this.amount
        }).toString();
        fetch(window['API_URL'] + '/api/v4/my-finances/withdraw?' + paramsUrl, {
          method: 'POST',
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token')
          }
        }).then(res => res.json())
            .then(res => {
              this.requestId = res.data;
            });
      },
      confirmWithdrawal() {
        if (this.digitsValue.length < 6) return;

        this.confirming = true;

        const paramsUrl = new URLSearchParams({
          code: this.digitsValue
        });
        fetch(window['API_URL'] + '/api/v4/my-finances/withdraw/' + this.requestId + '?' + paramsUrl, {
          method: 'PATCH',
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token')
          }
        }).then(res => res.json())
            .then(res => {
              if (res.status === true) {
                this.withdrawalSuccess = true;
              } else {
                if (res.error === 'wrong_code') {
                  this.digitsError = Lang.texts('withdrawal')['wrongCode'];
                  this.confirming = false;
                }
              }
            });
      }
    }
  },
  mounted() {
    window['openWithdrawal'] = () => this.show();
  },
  computed: {
    cl() {
      return this.shown ? 'popup-shown' : '';
    },
    step() {
      if (this.wallets == null) return 0;

      if (this.network == null) return 1; // Select network

      if (this.address.length === 0) return 2; // Enter address

      let info = this.getAddressInfo();
      if (info === "error") return 2; // Enter address

      if (info.network !== 'mainnet') return 2; // Enter address

      if (this.wallet == null) return 3; // Select wallet

      // Enter amount
      if (this.amount == null || this.amount === '' || isNaN(this.amount) || this.amount === 0) return 4;
      if (this.amount > this.wallet.balance) return 4;
      if (this.amount < this.MIN_AMOUNT) return 4;

      if (this.requestId == null) return 5;

      if (!this.withdrawalSuccess) return 6;

      return 7;
    },
    addressInfo() {
      return this.getAddressInfo();
    },
    lang() {
      return Lang.texts('withdrawal')
    }
  }
}
</script>


<template>
  <div :class="'popup withdrawal ' + cl">
    <div class="popup-window" v-if="step <= 5">
      <div class="close" @click="hide()"></div>
      <h2>{{ lang['sendBtc'] }}</h2>

      <div v-if="step === 0" class="loading-small">
        {{ lang['loadingBalance'] }}
      </div>

      <template v-if="step >= 1">

        <div class="field-title">
          {{ lang['network'] }}
        </div>
        <select v-model="network" @change="calcFee()">
          <option :value="null">{{ lang['selectNetwork'] }}</option>
          <option value="blockchain">{{ lang['bitcoinNetwork'] }}</option>
          <option value="binance">{{ lang['binanceNetwork'] }}</option>
        </select>

        <div class="sub-div" :style="'visibility: ' + (step >= 2 ? 'visible' : 'hidden')">
          <div class="field-title">
            {{ lang['address'] }}
          </div>
          <input type="text"
                 @change="calcFee()"
                 @keyup="calcFee()"
                 :placeholder="lang['enterCryptoAddress']" v-model="address" />
          <div class="field-hint">
            <span class="danger" v-if="addressInfo === 'error'">
              {{ lang['invalidAddress'] }}
            </span>
            <template v-if="network === 'blockchain' && addressInfo != null && addressInfo !== 'error'">
              <span class="danger" v-if="addressInfo.network === 'testnet'">
                TestNet {{ addressInfo.type }} {{ lang['wallet'] }}
                ({{ lang['mainnetRequired'] }})
              </span>
              <span class="success" v-if="addressInfo.network === 'mainnet'">
                {{ lang['walletOk'] }}
              </span>
            </template>
            <template v-if="addressInfo == null || network === 'binance'">
              <template v-if="network === 'blockchain'" v-html="lang['mustBeBitcoinNetwork']"></template>
              <!--<template v-if="network === 'binance'" v-html="lang['mustBeBinanceNetwork']"></template>-->
            </template>
          </div>
          <div class="field-hint danger no-margin" v-html="lang['transactionsIrreversible']"></div>
        </div>

        <div class="sub-div" v-if="wallets.length > 1" :style="'visibility: ' + (step >= 3 ? 'visible' : 'hidden')">
          <div class="field-title">
            {{ lang['sendFrom'] }}
          </div>
          <select v-model="wallet">
            <option :value="null">{{ lang['selectWallet'] }}</option>
            <option v-for="wallet in wallets" :value="wallet">{{ wallet.code }}</option>
          </select>
        </div>

        <div :style="'visibility: ' + (step >= 4 ? 'visible' : 'hidden')">
          <div class="field-title">
            {{ lang['amount'] }}
          </div>
          <div class="field-group">
            <input :placeholder="lang['enterAmount']" v-model="amount"
                   @change="calcFee()"
                   @keyup="calcFee()"
                   type="number"
                   step="0.0005"
                   :min="0.0005"
                   :max="wallet != null ? wallet.balance : 1" />
            <div @click="setMaxAmount()">
              {{ lang['max'] }}
            </div>
          </div>
          <div :class="'field-hint ' + (wallet != null && amount < MIN_AMOUNT ? 'danger' : '')">
            {{ lang['minAmount'] }}
            <span v-if="wallet == null">
              ---
            </span>
            <span v-if="wallet != null">
              {{ MIN_AMOUNT }} BTC
            </span>
          </div>
          <div :class="'field-hint no-margin ' + (wallet != null && amount > wallet.balance ? 'danger' : '')">
            {{ lang['available'] }}
            <span v-if="wallet == null">
              ---
            </span>
            <span v-if="wallet != null">
              {{ wallet.balance }} BTC
            </span>
          </div>

          <div class="field-hint no-margin danger" v-if="wallet != null && wallet.balance < MIN_AMOUNT">
            {{ lang['notEnoughBalance'] }}
          </div>
        </div>

        <div class="sub-div" :style="'visibility: ' + (step >= 5 ? 'visible' : 'hidden')">
          <div class="line"></div>

          <div class="receive">
            <div class="item-title">
              {{ lang['receiveAmount'] }}
            </div>
            <div class="item-value">
              <div class="btc">
                <template v-if="btcValue == null">
                  {{ lang['calculating'] }}
                </template>
                <template v-if="btcValue === 0">
                  --- BTC
                </template>
                <template v-if="btcValue != null && btcValue > 0">
                  &asymp; {{ btcValue }} BTC
                </template>
              </div>
              <div class="fee">
                {{ lang['networkFee'] }}
                <template v-if="feeValue == null">
                  {{ lang['calculating'] }}
                </template>
                <template v-if="feeValue === 0">
                  0 BTC
                </template>
                <template v-if="feeValue != null && feeValue > 0">
                  &asymp; {{ feeValue }} BTC
                </template>
              </div>
            </div>
          </div>

          <div class="btn btn-gold" @click="requestWithdrawal()" v-if="!requesting">
            {{ lang['continue'] }}
          </div>

          <div class="btn btn-simple" v-if="requesting">
            {{ lang['checking'] }}
          </div>

        </div>
      </template>

    </div>
    <div class="popup-window center" v-if="step === 6">
      <div class="close" @click="hide()"></div>
      <h2>{{ lang['confirmWithdrawal'] }}</h2>

      <div class="field-title">{{ lang['verifyWithdrawal'] }}</div>
      <div class="digits-hint">
        {{ lang['sixDigitsSent'] }}
      </div>

      <div :class="'digits ' + (digitsFocused ? 'focus' : '')">
        <div>
          <template v-if="digitsValue.length >= 1">
            {{ digitsValue[0] }}
          </template>
        </div>
        <div>
          <template v-if="digitsValue.length >= 2">
            {{ digitsValue[1] }}
          </template>
        </div>
        <div>
          <template v-if="digitsValue.length >= 3">
            {{ digitsValue[2] }}
          </template>
        </div>
        <div>
          <template v-if="digitsValue.length >= 4">
            {{ digitsValue[3] }}
          </template>
        </div>
        <div>
          <template v-if="digitsValue.length >= 5">
            {{ digitsValue[4] }}
          </template>
        </div>
        <div>
          <template v-if="digitsValue.length >= 6">
            {{ digitsValue[5] }}
          </template>
        </div>
        <input type="text" pattern="\d*" maxlength="6" v-model="digitsValue"
               @focus="digitsFocused = true" @blur="digitsFocused = false">

      </div>
      <div class="digits-error">
        <template v-if="digitsError != null">
          {{ digitsError }}
        </template>
        <template v-if="digitsError == null">
          &nbsp;
        </template>
      </div>

      <template v-if="!confirming">
        <div class="btn btn-simple" v-if="digitsValue.length < 6">
          {{ lang['confirm'] }}
        </div>
        <div class="btn btn-gold" v-if="digitsValue.length === 6" @click="confirmWithdrawal()">
          {{ lang['confirm'] }}
        </div>
      </template>
      <div class="btn btn-simple" v-if="confirming">
        {{ lang['checking'] }}
      </div>
    </div>

    <div class="popup-window center" v-if="step === 7">
      <div class="close" @click="hide()"></div>
      <div class="window-title">{{ lang['withdrawalRequested'] }}</div>
      <div class="success">
        {{ lang['willBeWithdrawn'] }}
      </div>
      <div class="link-button gold-gradient btn-submit" @click="complete()">
        {{ lang['close'] }}
      </div>
    </div>
  </div>
</template>